import { render, staticRenderFns } from "./MenuEditor.vue?vue&type=template&id=558134a6"
import script from "./MenuEditor.vue?vue&type=script&lang=js"
export * from "./MenuEditor.vue?vue&type=script&lang=js"
import style0 from "./MenuEditor.vue?vue&type=style&index=0&id=558134a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports